import React  from "react";
import { useParams } from 'react-router-dom';
import TrainingModuleRequestForm from "./components/TrainingModuleRequestForm";
import { Card } from "antd";

const EditTrainingModuleRequest = () => {

	const { trainingModuleId } = useParams();

	return (
	    <div>
	      <Card extra={"w-full h-full p-4"}>
			<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<TrainingModuleRequestForm recordId={trainingModuleId} mode="edit"/>
			</div>
		  </Card>
	    </div>
    );
};

export default EditTrainingModuleRequest;